import BlockTypes from '@slite/editor/lib/types/BlockTypes'
import getBlockId from '@slite/editor/lib/utils/getBlockId'

const TITLE_BLOCK_TYPES = [BlockTypes.H1, BlockTypes.H2, BlockTypes.H3]
const TITLE_BLOCK_LEVELS = {
  [BlockTypes.H1]: 1,
  [BlockTypes.H2]: 2,
  [BlockTypes.H3]: 3,
}

export default function getHeadersStateFromEditor(editor) {
  const { headers } = editor.value.document.nodes.reduce(
    ({ lastHeaderIdByLevel, headers }, block) => {
      const blockIsATitle = TITLE_BLOCK_TYPES.includes(block.type)
      const blockIsEmpty = !block.text

      if (!blockIsATitle || blockIsEmpty) {
        return { lastHeaderIdByLevel, headers }
      }
      const level = TITLE_BLOCK_LEVELS[block.type]
      const id = getBlockId(block)
      const parentId = lastHeaderIdByLevel[level - 1]

      return {
        lastHeaderIdByLevel: {
          ...lastHeaderIdByLevel,
          [level]: id,
        },
        headers: [
          ...headers,
          {
            level,
            text: block.text,
            id,
            parentId,
          },
        ],
      }
    },
    { lastHeaderIdByLevel: {}, headers: [] }
  )
  return headers
}
